<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import branchApi from '@/services/branches/branch.api'
import { statusFormatter } from '@/utils/tableFormatter'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'side-menu-branches-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    showEdit(e, cell) {
      this.$router.push({
        name: 'side-menu-branches-edit',
        params: { uuid: cell.getData().uuid }
      })
    },
    showPlaces(e, cell) {
      this.$router.push({
        name: 'side-menu-branch-places',
        params: { branchUUID: cell.getData().uuid }
      })
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    },
    editFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.edit') +
        '</button></div>'
      )
    },
    placesFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-instagram detail-action">' +
        this.$t('branchPlace.list') +
        '</button></div>'
      )
    }
  },
  mounted() {
    const translate = this.$t
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function (url, config, params) {
        console.log(url)
        console.log(params)
        console.log(config)
        return branchApi.getList(params.page, params.size)
      },
      ajaxResponse: function (url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.title'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${cell.getData().title}</div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'status',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: (cell) => statusFormatter(cell, translate, 'She')
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionEdit',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionPlaces',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.placesFormatter,
          cellClick: this.showPlaces
        }
      ]
    })
  }
})
</script>
